import { render, staticRenderFns } from "./categoryList.vue?vue&type=template&id=1998de95&scoped=true&"
import script from "./categoryList.vue?vue&type=script&lang=js&"
export * from "./categoryList.vue?vue&type=script&lang=js&"
import style0 from "./categoryList.vue?vue&type=style&index=0&id=1998de95&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1998de95",
  null
  
)

export default component.exports